module.exports = {
  FULL_HOST: {
    CL: 'https://beta.falabella.com/falabella-cl',
    CL_SODIMAC: 'https://beta-sodimac.falabella.com/sodimac-cl',
    CL_SO_COM: 'https://beta.sodimac.cl/sodimac-cl',
    MX_SO_RETAIL: 'https://beta.sodimac.com.mx/sodimac-mx',
    CL_TO_COM: 'https://beta.tottus.cl/tottus-cl',
    CL_LINIO: 'https://beta-linio.falabella.com/linio-cl',
    CL_TOTTUS: 'https://beta-tottus.falabella.com/tottus-cl',
    CL_TIENDA: 'https://beta-tienda.falabella.com/falabella-cl',
    PE: 'https://beta.falabella.com.pe/falabella-pe',
    PE_LINIO: 'https://beta-linio.falabella.com.pe/linio-pe',
    PE_TOTTUS: 'https://beta-tottus.falabella.com.pe/tottus-pe',
    PE_SODIMAC: 'https://beta-sodimac.falabella.com.pe/sodimac-pe',
    PE_SO_COM: 'https://beta.sodimac.com.pe/sodimac-pe',
    PE_TO_COM: 'https://beta.tottus.com.pe/tottus-pe',
    PE_TIENDA: 'https://beta-tienda.falabella.com.pe/falabella-pe',
    CO: 'https://beta.falabella.com.co/falabella-co',
    CO_LINIO: 'https://beta-linio.falabella.com.pe/linio-co',
    CO_TOTTUS: 'https://beta-tottus.falabella.com.co/tottus-co',
    CO_SODIMAC: 'https://beta-sodimac.falabella.com.co/sodimac-co',
    CO_TIENDA: 'https://beta-tienda.falabella.com.co/falabella-co',
    CO_HOMECENTER: 'https://beta-homecenter.falabella.com.co/homecenter-co',
    AR: 'https://beta.falabella.com.ar/falabella-ar',
  },
};
